import { html, css, unsafeCSS } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { FormBase } from "./formBase";
import "../custom-stepper";
import tailwindStyles from "../../../index.css?inline";
import { gatewaySelector } from "../../../core/mixins/adaptiveui-mixin";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { query } from "lit/decorators.js";
import { authDiagram } from "../../../core/diagrams/authDiagram";

interface FormData {
  _details: any;
  title?: string;
}

@customElement("session-x")
export class SessionX extends FormBase {
  static styles = [
    unsafeCSS(tailwindStyles),
    css`
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }

      .container {
        display: flex;
        min-height: 100vh;
        width: 100vw;
        background: white;
        overflow: hidden;
      }

      .image-section {
        flex: 1;
        background: var(--md-sys-color-surfaceContainerLowest);
        padding: 20px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        min-height: 500px;
        display: flex;
      }

      .content-section {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 0;
        overflow: hidden;
        height: 100vh;
      }

      .card {
        display: flex;
        flex-direction: column;
        height: 100%;
        background: white;
        overflow: hidden;
      }

      .card-header {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
      }

      .card-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .card-content-scrollable {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
      }

      .form-scroll-container {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 2rem;
        width: 100%;
        align-content: center;
      }

      .form-container {
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        border-radius: 4px;
        padding: 24px;
      }

      .header-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
      }

      .header-title {
        font-style: normal;
        font-size: 1.5rem;
        line-height: 1.4;
        margin: 2rem 0;
        color: var(--md-sys-color-on-surface);
      }

      /* Logo styling for mobile */
      .mobile-logo {
        display: none;
        width: 80px;
        height: auto;
        margin-bottom: 1rem;
      }

      /* NenaCall mobile image styling */
      .nenacall-mobile-image {
        display: none;
        width: 100%;
        max-width: 280px;
        height: auto;
        margin-bottom: 1.5rem;
        border-radius: 12px;
        object-fit: cover;
      }
      
      /* ─── NenaSasa specific styles ─── */
      .nenasasa-left-panel {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        width: 100%;
        position: relative;
        overflow: hidden;
        padding: 24px 16px 24px 24px;
        background-color: #FFFFFF;
      }

      .nenasasa-image-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        background-image: url('/static/dsv4.0/images/web/left_panel_bg.png');
        background-size: contain;
        background-position: top center;
        background-repeat: no-repeat;
        position: relative;
        padding-top: 44px;
        padding-bottom: 20px;
      }
      /* ─────────────────────────────── */

      /* Stepper specific styles */
      .stepper-container {
        flex-shrink: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 1rem;
      }

      /* Ensure stepper is always visible when there are steps */
      .stepper-visible {
        display: flex !important;
      }
    
      @media (max-width: 768px) {
        .container {
          flex-direction: column;
        }

        .image-section {
          min-height: 300px;
          flex: none;
          height: 35vh;
          border-radius: 0 0 30px 30px;
          display: none;
        }

        .content-section {
          flex: 1;
          width: 100%;
        }

        /* Show mobile logo for non-NenaCall gateways */
        .mobile-logo {
          display: block;
          width: 100px;
          height: auto;
          margin: 0 auto 1rem auto;
        }

        /* Show NenaCall mobile image */
        .nenacall-mobile-image {
          display: block;
          margin: 0 auto 1.5rem auto;
        }

        .card-header {
          padding-top: 1.5rem;
          padding-bottom: 1rem;
        }

        .header-title {
          font-size: 1.25rem;
          margin: 0.5rem 0 1rem 0;
        }

        /* Hide stepper on mobile for first step only */
        .stepper-hidden-mobile {
          display: none !important;
        }

        .form-scroll-container {
          padding: 1.5rem;
        }

        .form-container {
          padding: 0;
          background: transparent;
        }

        .nenasasa-left-panel {
          padding: 12px 8px 12px 12px;
          height: 35vh;
          border-radius: 0 0 30px 30px;
        }

        .nenasasa-image-container {
          background-image: url('/static/dsv4.0/images/web/Left_bg.png');
          background-size: contain;
          background-position: top center;
          background-repeat: no-repeat;
          padding-top: 16px;
          padding-bottom: 12px;
        }

        /* Mobile stepper adjustments */
        .stepper-container {
          margin-top: 0.5rem;
          padding: 0 1rem;
        }
      }

      @media (max-width: 480px) {
        .mobile-logo {
          width: 80px;
        }

        .nenacall-mobile-image {
          max-width: 240px;
        }

        .header-title {
          font-size: 1.1rem;
        }

        .form-scroll-container {
          padding: 1rem;
        }

        .form-container {
          padding: 0;
          background: transparent;
        }

        .nenasasa-left-panel {
          height: 32vh;
          padding: 8px 4px 8px 8px;
        }

        .nenasasa-image-container {
          padding-top: 12px;
          padding-bottom: 8px;
        }
      }

      @media (min-width: 1440px) {
        .nenasasa-left-panel {
          padding: 32px 20px 32px 32px;
        }

        .nenasasa-image-container {
          padding-top: 56px;
          padding-bottom: 28px;
        }
      }

      .nenacall-left-panel {
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        padding: 2rem;
      }

      .nikobizznet-left-panel {

  background-image: 
    linear-gradient(167.12deg, rgba(0, 8, 32, 0.94) 0%, rgba(0, 24, 72, 0.8) 35%, rgba(0, 18, 60, 0.82) 65%, rgba(0, 6, 26, 0.96) 100%),
    url('/static/dsv4.0/images/web/NikobizzNet_bg.jpg');

  /* Positioning and scaling properties */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

        overflow: hidden;
          flex: 1;
        padding: 20px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        min-height: 500px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .mipay-left-panel {
        background-image: url('/static/dsv4.0/images/web/mipay_landingBg.svg') !important;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        text-align: center;
        position: relative;
      }

      .nikobizz-left-panel {
        background-image: url('/static/dsv4.0/images/web/nikobizz_bg_landing.svg') !important;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        text-align: center;
        position: relative;
      }

      .default-left-panel {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 2rem;
        text-align: center;
        color: white;
      }

      /* Loading overlay and other styles remain the same... */
      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(var(--md-sys-color-primary-rgb), 0.5);
        backdrop-filter: blur(4px);
        z-index: 50;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      /* Scrollbar styling */
      .scrollbar-custom {
        scrollbar-width: thin;
        scrollbar-color: #9ca3af #f3f4f6;
      }

      .scrollbar-custom::-webkit-scrollbar {
        width: 6px;
      }

      .scrollbar-custom::-webkit-scrollbar-track {
        background: #f3f4f6;
        border-radius: 3px;
      }

      .scrollbar-custom::-webkit-scrollbar-thumb {
        background-color: #9ca3af;
        border-radius: 3px;
      }


/* ---------------------------------------------------------------
   ANIMATIONS
   --------------------------------------------------------------- */
@keyframes pulse-green {
  0%, 100% { box-shadow: 0 0 0 2px rgba(52, 199, 89, 0.28); }
  50%       { box-shadow: 0 0 0 5px rgba(52, 199, 89, 0.1); }
}

/* ---------------------------------------------------------------
   BASE RESET
   --------------------------------------------------------------- */
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

html {
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  font-family: var(--md-sys-typescale-font);
  background-color: var(--md-sys-color-background);
  color: var(--md-sys-color-on-surface);
  min-height: 100vh;
  line-height: 1.5;
}

a { color: var(--md-sys-color-primary); text-decoration: none; }
a:hover { text-decoration: underline; }
button { font-family: var(--md-sys-typescale-font); cursor: pointer; border: none; background: none; }
input, select, textarea { font-family: var(--md-sys-typescale-font); }
svg { display: block; flex-shrink: 0; }

/* ---------------------------------------------------------------
   AUTH LAYOUT — SPLIT PANEL
   --------------------------------------------------------------- */
.auth-layout {
  display: flex;
  height: 100vh;
  min-height: 640px;
  overflow: hidden;
}

/* Brand-only layout — form panel removed; brand panel stays on the left,
   the freed-up space becomes a soft light field. */
.auth-layout.brand-only {
  background: linear-gradient(155deg, rgb(248 249 255) 0%, rgb(240 240 252) 100%);
  width:50%;
}

/* ---------------------------------------------------------------
   BRAND PANEL — LEFT
   --------------------------------------------------------------- */
.auth-brand-panel {
  background:
    linear-gradient(
      162deg,
      rgba(0, 8, 32, 0.94) 0%,
      rgba(0, 24, 72, 0.80) 35%,
      rgba(0, 18, 60, 0.82) 65%,
      rgba(0, 6, 26, 0.96) 100%
    ),
    url('/static/dsv4.0/images/web/NikobizzNet_bg.jpg')
    center top / cover no-repeat;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 40px 48px 36px;
  color: white;
    flex: 1;
      /* Positioning and scaling properties */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* Dot-grid texture */
.auth-brand-panel::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(255,255,255,0.05) 1px, transparent 1px);
  background-size: 26px 26px;
  pointer-events: none;
  z-index: 0;
}

/* Right-edge vignette — blends into form panel */
.auth-brand-panel::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  background: linear-gradient(to right, transparent, rgba(0, 6, 24, 0.5));
  pointer-events: none;
  z-index: 0;
}

/* Logo */
.brand-logo-img { height: 48px; width: auto; display: block; }
.auth-brand-panel .brand-logo-img { filter: brightness(0) invert(1); }

/* ── Top bar ── */
.brand-top {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.brand-official-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px 5px 9px;
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: var(--md-sys-shape-corner-full);
  background: rgba(255,255,255,0.07);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: rgba(255,255,255,0.82);
  text-transform: uppercase;
}

/* ── Hero section (login page) ── */
.brand-hero {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  padding: 36px 0 28px;
}

.brand-hero-eyebrow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.45);
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.brand-hero-eyebrow::before {
  content: '';
  display: inline-block;
  width: 20px;
  height: 1.5px;
  background: rgba(255,255,255,0.32);
  border-radius: 1px;
  flex-shrink: 0;
}

.brand-hero-title {
  font-size: 42px;
  font-weight: 300;
  line-height: 1.12;
  color: white;
  letter-spacing: -0.8px;
  margin-bottom: 16px;
}
.brand-hero-accent {
  font-weight: 700;
  background: linear-gradient(135deg, #ffffff 0%, #a8c4ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-hero-body {
  font-size: 14px;
  color: rgba(255,255,255,0.60);
  line-height: 1.65;
  max-width: 305px;
  margin-bottom: 24px;
}

.brand-quote-card {
  padding: 15px 18px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: var(--md-sys-shape-corner-medium);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  max-width: 320px;
}
.brand-quote-card p {
  font-size: 12px;
  color: rgba(255,255,255,0.70);
  line-height: 1.65;
  font-style: italic;
  margin: 0;
}

/* ── Bottom strip ── */
.brand-bottom {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex-shrink: 0;
}

/* Stats bar */
.brand-stats {
  display: flex;
  align-items: center;
  padding: 14px 0;
  border-top: 1px solid rgba(255,255,255,0.1);
  border-bottom: 1px solid rgba(255,255,255,0.1);
}
.brand-stat-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}
.brand-stat-value {
  font-size: 17px;
  font-weight: 700;
  color: white;
  letter-spacing: -0.3px;
  line-height: 1;
}
.brand-stat-label {
  font-size: 10px;
  font-weight: 500;
  color: rgba(255,255,255,0.45);
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.brand-stat-divider {
  width: 1px;
  height: 28px;
  background: rgba(255,255,255,0.14);
  flex-shrink: 0;
}

/* Bottom footer row */
.brand-bottom-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.brand-partner-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  font-size: 10px;
  font-weight: 500;
  color: rgba(255,255,255,0.38);
  letter-spacing: 0.3px;
}
.brand-dot-sep { color: rgba(255,255,255,0.22); }

/* System status */
.brand-status {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  color: rgba(255,255,255,0.50);
  letter-spacing: 0.2px;
  flex-shrink: 0;
}
.brand-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: rgb(52 199 89);
  box-shadow: 0 0 0 2px rgba(52,199,89,0.28);
  animation: pulse-green 2.5s ease infinite;
  flex-shrink: 0;
}

/* Simplified brand panel (verification / recovery flows) */
.brand-panel-centered {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  z-index: 1;
  gap: 16px;
}

.brand-panel-icon-wrap {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0.07) 100%);
  border: 1px solid rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.14);
}

.brand-panel-heading {
  font-size: 28px;
  font-weight: 600;
  color: white;
  line-height: 1.22;
  letter-spacing: -0.4px;
}
.brand-panel-text {
  font-size: var(--md-sys-typescale-body-large-size);
  color: rgba(255,255,255,0.63);
  line-height: 1.65;
  max-width: 285px;
}

/* Minimal bottom for secondary pages */
.brand-bottom-minimal {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 20px;
  border-top: 1px solid rgba(255,255,255,0.1);
  flex-shrink: 0;
}

/* ---------------------------------------------------------------
   FORM PANEL — RIGHT
   --------------------------------------------------------------- */
.auth-form-panel {
  flex: 1;
  height: 100vh;
  background: linear-gradient(155deg, rgb(248 249 255) 0%, rgb(240 240 252) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 52px;
  overflow-y: auto;
}

.auth-form-container {
  width: 100%;
  max-width: 440px;
  background: rgb(255 255 255);
  border-radius: 20px;
  border: 1px solid var(--md-sys-color-outline-variant);
  padding: 40px 44px;
  box-shadow:
    0 1px 2px rgba(0, 44, 112, 0.04),
    0 4px 20px rgba(0, 44, 112, 0.07),
    0 16px 56px rgba(0, 44, 112, 0.05);
}

/* Form header */
.auth-form-header { margin-bottom: 26px; }

.form-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--md-sys-typescale-label-medium-size);
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--md-sys-color-primary);
  margin-bottom: 10px;
}
.form-eyebrow::before {
  content: '';
  width: 3px;
  height: 14px;
  background-color: var(--md-sys-color-primary);
  border-radius: 2px;
  flex-shrink: 0;
}

.auth-form-header h1,
.auth-form-header h2 {
  font-size: var(--md-sys-typescale-headline-small-size);
  font-weight: 700;
  color: var(--md-sys-color-on-surface);
  line-height: var(--md-sys-typescale-headline-small-line-height);
  margin-bottom: 6px;
  letter-spacing: -0.3px;
}
.auth-form-header p {
  font-size: var(--md-sys-typescale-body-medium-size);
  color: var(--md-sys-color-on-surface-variant);
  line-height: 1.55;
}
.auth-form-header p strong {
  color: var(--md-sys-color-on-surface);
  font-weight: 500;
}

/* ---------------------------------------------------------------
   FORM COMPONENTS
   --------------------------------------------------------------- */
.auth-form { display: flex; flex-direction: column; gap: 20px; }

.form-field { display: flex; flex-direction: column; gap: 6px; }

.form-label {
  font-size: var(--md-sys-typescale-label-medium-size);
  font-weight: 600;
  letter-spacing: var(--md-sys-typescale-label-medium-tracking);
  color: var(--md-sys-color-on-surface);
  line-height: 1;
}

/* Input */
.form-input {
  width: 100%;
  height: 42px;
  padding: 0 12px;
  font-size: var(--md-sys-typescale-body-medium-size);
  font-family: var(--md-sys-typescale-font);
  font-weight: 400;
  color: var(--md-sys-color-on-surface);
  background-color: var(--md-sys-color-surface-container-lowest);
  border: 1px solid var(--md-sys-color-outline-variant);
  border-radius: var(--md-sys-shape-corner-extra-small);
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  letter-spacing: var(--md-sys-typescale-body-medium-tracking);
}
.form-input::placeholder { color: var(--md-sys-color-outline); }
.form-input:hover:not(:disabled) { border-color: var(--md-sys-color-outline); }
.form-input:focus {
  border-color: var(--md-sys-color-primary);
  box-shadow: 0 0 0 3px rgba(0, 44, 112, 0.1);
}
.form-input:disabled {
  background-color: var(--md-sys-color-surface-container);
  color: var(--md-sys-color-on-surface-variant);
  cursor: not-allowed;
}
.form-input.has-error { border-color: var(--md-sys-color-error); }
.form-input.has-error:focus { box-shadow: 0 0 0 3px rgba(186, 26, 26, 0.1); }

/* Leading-icon wrapper (email / standalone fields) */
.input-field-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.input-field-wrap .form-input { padding-left: 38px; }

/* Combined wrapper (password — lead icon + trail button) */
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.input-wrapper .form-input { padding-right: 42px; }
.input-wrapper.has-lead .form-input { padding-left: 38px; }

/* Lead icon */
.input-lead-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--md-sys-color-outline);
  pointer-events: none;
  z-index: 1;
  flex-shrink: 0;
  transition: color 0.15s ease;
}
.input-field-wrap:focus-within .input-lead-icon,
.input-wrapper:focus-within .input-lead-icon {
  color: var(--md-sys-color-primary);
}

/* Trail icon button (eye toggle) */
.input-icon-btn {
  position: absolute;
  right: 1px;
  top: 1px;
  bottom: 1px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--md-sys-color-on-surface-variant);
  background: none;
  border: none;
  border-radius: 0 3px 3px 0;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s ease;
}
.input-icon-btn:hover { color: var(--md-sys-color-on-surface); }

/* Field messages */
.form-error-msg {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: var(--md-sys-typescale-label-small-size);
  font-weight: 500;
  letter-spacing: var(--md-sys-typescale-label-small-tracking);
  color: var(--md-sys-color-error);
  line-height: 1.2;
}
.form-hint {
  font-size: var(--md-sys-typescale-body-small-size);
  color: var(--md-sys-color-on-surface-variant);
  letter-spacing: var(--md-sys-typescale-body-small-tracking);
  line-height: 1.4;
}

/* Inline row */
.form-row { display: flex; align-items: center; }
.form-row-between { justify-content: space-between; }

/* Security trust row */
.form-trust-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding-top: 10px;
}
.form-trust-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 500;
  color: var(--md-sys-color-on-surface-variant);
  letter-spacing: 0.15px;
  opacity: 0.75;
}
.form-trust-item svg { color: var(--md-sys-color-primary); opacity: 0.6; }
.form-trust-sep {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: var(--md-sys-color-outline-variant);
  flex-shrink: 0;
}

/* ---------------------------------------------------------------
   CHECKBOX — custom styled
   --------------------------------------------------------------- */
.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: var(--md-sys-typescale-body-small-size);
  color: var(--md-sys-color-on-surface-variant);
  user-select: none;
}
.checkbox-label input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border: 1.5px solid var(--md-sys-color-outline-variant);
  border-radius: 3px;
  background: white;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.checkbox-label input[type="checkbox"]:hover { border-color: var(--md-sys-color-primary); }
.checkbox-label input[type="checkbox"]:checked {
  background-color: var(--md-sys-color-primary);
  border-color: var(--md-sys-color-primary);
}
.checkbox-label input[type="checkbox"]:checked::after {
  content: '';
  position: absolute;
  left: 4px;
  top: 1.5px;
  width: 5px;
  height: 9px;
  border: 2px solid white;
  border-top: none;
  border-left: none;
  transform: rotate(45deg);
}
.checkbox-label input[type="checkbox"]:focus-visible {
  outline: 2px solid var(--md-sys-color-primary);
  outline-offset: 2px;
}

/* ---------------------------------------------------------------
   BUTTONS
   --------------------------------------------------------------- */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 42px;
  padding: 0 24px;
  font-family: var(--md-sys-typescale-font);
  font-size: var(--md-sys-typescale-label-large-size);
  font-weight: 600;
  letter-spacing: var(--md-sys-typescale-label-large-tracking);
  border-radius: var(--md-sys-shape-corner-full);
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease;
  outline: none;
  white-space: nowrap;
  text-decoration: none;
}

.btn-primary {
  background-color: var(--md-sys-color-primary);
  color: var(--md-sys-color-on-primary);
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 44, 112, 0.28);
}
.btn-primary:hover {
  background-color: rgb(0 38 96);
  box-shadow: 0 4px 18px rgba(0, 44, 112, 0.38);
  transform: translateY(-1px);
}
.btn-primary:active {
  background-color: rgb(0 30 80);
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 44, 112, 0.28);
}
.btn-primary:focus { box-shadow: 0 0 0 3px rgba(0, 44, 112, 0.22), 0 2px 8px rgba(0, 44, 112, 0.28); }

.btn-outlined {
  background-color: transparent;
  color: var(--md-sys-color-primary);
  border: 1.5px solid var(--md-sys-color-outline-variant);
  width: 100%;
}
.btn-outlined:hover { background-color: rgba(0, 44, 112, 0.05); border-color: rgba(0, 44, 112, 0.4); }

.btn-text {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  color: var(--md-sys-color-primary);
  font-size: var(--md-sys-typescale-label-medium-size);
  font-weight: 500;
  font-family: var(--md-sys-typescale-font);
  letter-spacing: var(--md-sys-typescale-label-medium-tracking);
  border: none;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: var(--md-sys-shape-corner-extra-small);
  transition: background-color 0.15s ease;
  outline: none;
}
.btn-text:hover { background-color: rgba(0, 44, 112, 0.06); text-decoration: none; }

.btn-gap { margin-top: 4px; }

/* ---------------------------------------------------------------
   DIVIDER
   --------------------------------------------------------------- */
.divider { display: flex; align-items: center; gap: 12px; }
.divider::before,
.divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background-color: var(--md-sys-color-outline-variant);
}
.divider span {
  font-size: var(--md-sys-typescale-label-small-size);
  font-weight: 500;
  letter-spacing: 0.8px;
  color: var(--md-sys-color-on-surface-variant);
  white-space: nowrap;
  text-transform: uppercase;
}

/* ---------------------------------------------------------------
   ALERTS
   --------------------------------------------------------------- */
.alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: var(--md-sys-shape-corner-small);
  font-size: var(--md-sys-typescale-body-small-size);
  line-height: 1.5;
}
.alert-error {
  background-color: var(--md-sys-color-error-container);
  color: var(--md-sys-color-on-error-container);
  border: 1px solid rgba(186, 26, 26, 0.18);
}
.alert-info {
  background-color: var(--md-sys-color-secondary-container);
  color: var(--md-sys-color-on-secondary-container);
  border: 1px solid rgba(83, 94, 124, 0.2);
}
.alert-success {
  background-color: rgb(208 248 219);
  color: rgb(0 55 16);
  border: 1px solid rgba(0, 100, 40, 0.18);
}
.alert-icon { flex-shrink: 0; width: 16px; height: 16px; margin-top: 1px; }

/* ---------------------------------------------------------------
   OTP INPUTS
   --------------------------------------------------------------- */
.otp-inputs { display: flex; gap: 10px; justify-content: center; }

.otp-input {
  width: 54px;
  height: 58px;
  text-align: center;
  font-size: var(--md-sys-typescale-headline-small-size);
  font-weight: 600;
  font-family: var(--md-sys-typescale-font);
  color: var(--md-sys-color-on-surface);
  background-color: var(--md-sys-color-surface-container-lowest);
  border: 1.5px solid var(--md-sys-color-outline-variant);
  border-radius: var(--md-sys-shape-corner-small);
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  caret-color: var(--md-sys-color-primary);
  letter-spacing: 0;
}
.otp-input:focus {
  border-color: var(--md-sys-color-primary);
  box-shadow: 0 0 0 3px rgba(0, 44, 112, 0.1);
}
.otp-input.has-value {
  border-color: var(--md-sys-color-primary);
  background-color: rgba(0, 44, 112, 0.03);
}
.otp-input.has-error { border-color: var(--md-sys-color-error); }

/* ---------------------------------------------------------------
   PASSWORD STRENGTH
   --------------------------------------------------------------- */
.password-strength { display: flex; flex-direction: column; gap: 6px; }

.strength-bars { display: flex; gap: 4px; }
.strength-bar {
  flex: 1;
  height: 3px;
  border-radius: 2px;
  background-color: var(--md-sys-color-outline-variant);
  transition: background-color 0.25s ease;
}
.strength-bar.weak   { background-color: rgb(186 26 26); }
.strength-bar.fair   { background-color: rgb(215 144 0); }
.strength-bar.good   { background-color: rgb(0 109 64); }
.strength-bar.strong { background-color: rgb(0 109 64); }

.strength-label {
  font-size: var(--md-sys-typescale-label-small-size);
  font-weight: 500;
  letter-spacing: var(--md-sys-typescale-label-small-tracking);
  color: var(--md-sys-color-on-surface-variant);
}

.pw-requirements { display: flex; flex-direction: column; gap: 6px; margin-top: 4px; }
.pw-req-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--md-sys-typescale-body-small-size);
  color: var(--md-sys-color-on-surface-variant);
  line-height: 1;
}
.pw-req-item.met { color: rgb(0 109 64); }

.pw-req-check {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1.5px solid var(--md-sys-color-outline-variant);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
}
.pw-req-item.met .pw-req-check { background-color: rgb(0 109 64); border-color: rgb(0 109 64); }

/* ---------------------------------------------------------------
   RESEND TIMER
   --------------------------------------------------------------- */
.resend-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
}
.resend-text {
  font-size: var(--md-sys-typescale-body-small-size);
  color: var(--md-sys-color-on-surface-variant);
  letter-spacing: var(--md-sys-typescale-body-small-tracking);
}
.resend-timer-count { color: var(--md-sys-color-primary); font-weight: 600; }

/* ---------------------------------------------------------------
   STEP INDICATOR
   --------------------------------------------------------------- */
.step-indicator { display: flex; align-items: center; gap: 6px; margin-bottom: 24px; }
.step-dot {
  height: 8px;
  border-radius: var(--md-sys-shape-corner-full);
  background-color: var(--md-sys-color-outline-variant);
  transition: all 0.2s ease;
  width: 8px;
}
.step-dot.active { width: 24px; background-color: var(--md-sys-color-primary); }
.step-dot.done   { background-color: rgb(177 197 255); }

/* ---------------------------------------------------------------
   BACK LINK — pill button style
   --------------------------------------------------------------- */
.back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--md-sys-typescale-label-medium-size);
  font-weight: 500;
  color: var(--md-sys-color-on-surface-variant);
  text-decoration: none;
  margin-bottom: 24px;
  padding: 6px 12px 6px 8px;
  border-radius: var(--md-sys-shape-corner-full);
  background: var(--md-sys-color-surface-container);
  border: 1px solid var(--md-sys-color-outline-variant);
  transition: all 0.15s ease;
  letter-spacing: var(--md-sys-typescale-label-medium-tracking);
  width: fit-content;
}
.back-link:hover {
  color: var(--md-sys-color-on-surface);
  background: var(--md-sys-color-surface-container-high);
  text-decoration: none;
}

/* ---------------------------------------------------------------
   AUTH FOOTER
   --------------------------------------------------------------- */
.auth-footer {
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid var(--md-sys-color-outline-variant);
  text-align: center;
}
.auth-footer p {
  font-size: var(--md-sys-typescale-body-small-size);
  color: var(--md-sys-color-on-surface-variant);
  line-height: 1.6;
  letter-spacing: var(--md-sys-typescale-body-small-tracking);
}
.auth-footer a { font-weight: 600; color: var(--md-sys-color-primary); }

/* Vertical separator */
.text-sep {
  display: inline-block;
  width: 1px;
  height: 11px;
  background-color: var(--md-sys-color-outline-variant);
  vertical-align: middle;
  margin: 0 8px;
}

/* ---------------------------------------------------------------
   TYPOGRAPHY UTILITIES
   --------------------------------------------------------------- */
.headline-small {
  font-size: var(--md-sys-typescale-headline-small-size);
  font-weight: var(--md-sys-typescale-headline-small-weight);
  line-height: var(--md-sys-typescale-headline-small-line-height);
}
.title-medium {
  font-size: var(--md-sys-typescale-title-medium-size);
  font-weight: var(--md-sys-typescale-title-medium-weight);
  line-height: var(--md-sys-typescale-title-medium-line-height);
  letter-spacing: var(--md-sys-typescale-title-medium-tracking);
}
.body-medium {
  font-size: var(--md-sys-typescale-body-medium-size);
  font-weight: var(--md-sys-typescale-body-medium-weight);
  line-height: var(--md-sys-typescale-body-medium-line-height);
}
.body-small {
  font-size: var(--md-sys-typescale-body-small-size);
  font-weight: var(--md-sys-typescale-body-small-weight);
  line-height: var(--md-sys-typescale-body-small-line-height);
  letter-spacing: var(--md-sys-typescale-body-small-tracking);
}
.label-large  { font-size: var(--md-sys-typescale-label-large-size);  font-weight: var(--md-sys-typescale-label-large-weight);  letter-spacing: var(--md-sys-typescale-label-large-tracking); }
.label-medium { font-size: var(--md-sys-typescale-label-medium-size); font-weight: var(--md-sys-typescale-label-medium-weight); letter-spacing: var(--md-sys-typescale-label-medium-tracking); }
.label-small  { font-size: var(--md-sys-typescale-label-small-size);  font-weight: var(--md-sys-typescale-label-small-weight);  letter-spacing: var(--md-sys-typescale-label-small-tracking); line-height: var(--md-sys-typescale-label-small-line-height); }

.color-primary        { color: var(--md-sys-color-primary); }
.color-on-surface     { color: var(--md-sys-color-on-surface); }
.color-on-surface-var { color: var(--md-sys-color-on-surface-variant); }
.color-error          { color: var(--md-sys-color-error); }

/* ---------------------------------------------------------------
   RESPONSIVE
   --------------------------------------------------------------- */
@media (max-width: 1024px) {
  .auth-brand-panel    { width: 40%; min-width: 340px; padding: 36px 36px 32px; }
  .auth-form-panel     { padding: 40px 36px; }
  .auth-form-container { padding: 36px 40px; }
  .brand-hero-title    { font-size: 34px; }
}

@media (max-height: 820px) {
  .brand-stats      { display: none; }
  .brand-quote-card { display: none; }
  .brand-hero-title { font-size: 32px; }
  .brand-hero-body  { margin-bottom: 16px; }
  .brand-hero       { padding: 20px 0; }
}

@media (max-width: 768px) {
  .auth-layout { flex-direction: column; height: auto; overflow: visible; }
  .auth-brand-panel {
    width: 100%;
    min-width: 0;
    height: auto;
    padding: 28px 24px 30px;
  }
  .brand-stats, .brand-quote-card, .brand-bottom-footer { display: none; }
  .brand-hero       { padding: 16px 0 0; }
  .brand-hero-title { font-size: 26px; }
  .brand-hero-body  { display: none; }
  .auth-form-panel  { height: auto; padding: 0; background: white; }
  .auth-form-container {
    border-radius: 0;
    border: none;
    box-shadow: none;
    padding: 28px 24px 44px;
    max-width: 100%;
  }
  .auth-footer { border-top: none; padding-top: 8px; }
  .otp-input { width: 44px; height: 50px; }
  .brand-panel-icon-wrap { width: 64px; height: 64px; border-radius: 16px; }
}

.brand-overlay {
            background-image: linear-gradient(162deg,
                rgb(24, 0, 173) 0%,
                rgba(24, 0, 173, 0.8) 35%,
                rgba(24, 0, 173, 0.6) 65%,
                rgb(24, 0, 173) 100%);
        }

        /* Right panel subtle gradient (155deg) */
        .form-panel {
            background-image: linear-gradient(155deg, #F8F9FF 0%, #F0F0FC 100%);
        }

        /* Gradient wordmark text (134deg, white to red) */
        .brand-gradient-text {
            background-image: linear-gradient(134deg, rgb(255, 255, 255) 0%, rgb(233, 68, 73) 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
        }

      
    `,
  ];

  @property({ type: Number }) pos = 0;
  @property({ type: Number }) maxPosReached = 0;
  @property({ type: Object }) af: FormData = {
    _details: undefined,
  };
  @property({ type: Object }) feed: FormData = {
    _details: undefined,
  };
  @property({ type: String }) logo = "";
  @property({ type: String }) headerBgColor = "";
  @property({ type: String }) details: string | Record<string, any> = "";
  @property({ type: Boolean }) paymentsPage = false;
  @property({ type: String }) loading = "false";
  @property({ type: String }) height = "";
  @property({ type: String }) maxHeight = "";
  @property({ type: Boolean }) isSectionPage = false;
  @property({ type: Array }) sections: any[] = [];

  // Gateway property to determine which layout to use
  @property({ type: String }) gateway = "";

  @state()
  private isMobileView = false;

  @query("#authDiagram") private _authDiagramSvg?: SVGSVGElement;

  _diagramRendered = false;

  protected firstUpdated(): void {
    this._renderAuthDiagram();
  }

  protected updated(changed: Map<string, unknown>): void {
    // Re-render if the gateway flips to zua ai after mount
    if (changed.has("gateway") || changed.has("af")) {
      this._renderAuthDiagram();
    }
  }

  private _renderAuthDiagram(): void {
    if (!this._authDiagramSvg) return;
    // Only run when we're actually showing the zua ai panel
    if (this.getGatewayName() !== "zua") return;
    authDiagram(this._authDiagramSvg);
    this._diagramRendered = true;
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.checkViewport();
    window.addEventListener("resize", this.checkViewport.bind(this));
  }

  disconnectedCallback(): void {
    window.removeEventListener("resize", this.checkViewport.bind(this));
    super.disconnectedCallback();
  }

  private checkViewport(): void {
    this.isMobileView = window.innerWidth <= 768;
  }

  private getGatewayName(): string {
    if (this.gateway) return this.gateway.toLowerCase();

    const gatewayName =
      localStorage.getItem("gateway_name") ||
      (window as any).gatewayDetails?.name ||
      "";

    const gatewayData = gatewaySelector(window.SERVICE_PAYLOAD);
    const logo = gatewayData._response?.logo;
    this.logo = logo;

    return gatewayName.toLowerCase();
  }

  private _onStepClick(event: CustomEvent<{ index: number }>): void {
    const index = event.detail.index;
    this._goToStep(index);
  }

  renderImageSection() {
    // Don't render image section on mobile
    if (this.isMobileView) {
      return html``;
    }

    const gatewayName = this.getGatewayName();
    switch (gatewayName) {
      case "nenacall":
        return html`
          <div class="image-section nenacall-left-panel">
            ${this.af._details && this.af._details.cover_image
              ? html`
                  <img
                    style="height: 79vh;"
                    src=${this.af._details.cover_image}
                    alt="Nena Call illustration"
                    class="nenacall-image"
                  />`
              : html`
                  <img
                    style="height: 79vh;"
                    src="/static/dsv4.0/images/web/nenacall.png"
                    alt="Nena Call illustration"
                    class="nenacall-image"
                  />`}
          </div>
        `;

      case "nenasasa":
        return html`
          <div class="image-section nenasasa-left-panel">
            <div class="nenasasa-image-container"></div>
          </div>
        `;

      case "nenasasa platform":
         return html`
          <div class="image-section nenasasa-left-panel">
            <div class="nenasasa-image-container"></div>
          </div>
        `;

      case "nenachat":
        return html`
           <aside class="hidden lg:flex relative w-[44%] overflow-hidden flex-col justify-between px-10 py-10">
            <img src="https://converted-components.netlify.app/images/nenachat-login-brand.png" alt="Stay connected with NenaChat"
                 class="absolute inset-0 h-full w-full object-cover" />
            <div class="absolute inset-0 brand-overlay"></div>

            <!-- Logo -->
            <div class="relative z-10">
                <img src="/static/dsv4.0/images/web/nenachat-logo-dark.png" alt="NenaChat" class="h-8 w-auto object-contain" />
            </div>

            <!-- Hero copy + quote -->
            <div class="relative z-10 max-w-[320px] mb-16">
                <div class="flex items-center gap-2 mb-4">
                    <span class="h-[1.5px] w-5 bg-white/60 rounded-sm"></span>
                    <span class="text-[11px] font-semibold text-white/80 tracking-[1.8px] uppercase">The AI Operating System</span>
                </div>

                <h2 class="text-[42px] font-light text-white leading-[1.12] tracking-[-0.8px] mb-3">
                    Welcome to<br />
                    <span class="font-bold brand-gradient-text">NenaChat</span>
                </h2>
                <p class="text-sm text-white/80 leading-[1.65] mb-6">
                    Your Personal Communications Agent. One subscription. One AI. One communications identity
                </p>

                <div class="rounded-xl border border-white/25 bg-white/15 backdrop-blur-[5px] px-[18px] py-4">
                    <p class="text-xs italic text-white/70 leading-[1.65]">
                        "If a task can be completed through communication, your AI assistant should be able to do it for you."
                    </p>
                </div>
            </div>

            <!-- Decorative pagination dots -->
            <div class="relative z-10 flex justify-center gap-4 text-[10px] font-medium text-white/[0.22] tracking-[0.3px]">
                <span>·</span>
                <span>·</span>
                <span>·</span>
            </div>
        </aside>
        `;

      case "mipay":
        return html`
          <div class="image-section mipay-left-panel">
            <div class="mipay-content">
              <img
                src="https://mipay.cash/media/administration_gateway_logo/mipay.png"
                alt="MiPay logo"
                class="mipay-logo"
              />
            </div>
          </div>
        `;

      case "nikobizz mobile":
        return html`
          <div class="image-section nikobizz-left-panel">
            <div class="mipay-content">
              <div class="default-content">
                <h2 class="default-title">${this.getDetailsTitle()}</h2>
                <p class="default-subtitle">${this.getDetailsSubtitle()}</p>
              </div>
            </div>
          </div>
        `;

      case "nikobizznet":
        return html`
          ${unsafeHTML(this.af._details.left_panel)}
        `;

      case "zua":
        return html `
        <style>

        .hero-only { flex: 1; min-height: 0; display: flex; }

        /* ── The card ──────────────────────────────────────────────────────── */
        .auth__card {
          position: relative; overflow: hidden; flex: 1; min-height: 0;
          display: flex; flex-direction: column; padding: 40px 48px 32px; border-radius: 24px; color: #fff; isolation: isolate;
          background:
            radial-gradient(70% 55% at 78% 58%, rgba(240, 128, 62, .30), transparent 65%),
            radial-gradient(60% 50% at 10% 100%, rgba(26, 115, 184, .38), transparent 70%),
            linear-gradient(160deg, #06496E 0%, #043D5D 38%, #021F31 100%);
          box-shadow: 0 30px 60px -30px rgba(2, 31, 49, .55);
        }
        /* Faint grid, masked to fade out towards the edges. */
        .auth__card::before {
          content: ''; position: absolute; inset: 0; z-index: -1;
          background-image: linear-gradient(rgba(255,255,255,.055) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.055) 1px, transparent 1px);
          background-size: 56px 56px;
          mask-image: radial-gradient(75% 60% at 55% 60%, #000 30%, transparent 85%);
          -webkit-mask-image: radial-gradient(75% 60% at 55% 60%, #000 30%, transparent 85%);
        }
        .auth__logo { height: 30px; width: auto; align-self: center; }
        .auth__eyebrow { margin-top: 26px; text-align: center; font-size: 11px; font-weight: 600; letter-spacing: .16em; text-transform: uppercase; color: rgba(255,255,255,.6); }
        .auth__headline { margin: 10px 0 0; text-align: center; font-size: clamp(30px, 2.6vw, 44px); line-height: 1.08; font-weight: 600; letter-spacing: -.02em; }
        .auth__headline em { font-style: normal; background: linear-gradient(90deg, var(--brand-gold), var(--brand-orange) 50%, #FF6B5E); -webkit-background-clip: text; background-clip: text; color: transparent; }
        .auth__lede { margin: 12px auto 0; max-width: 460px; text-align: center; font-size: 14px; line-height: 1.6; color: rgba(255,255,255,.75); }
        .auth__chips { display: flex; justify-content: center; gap: 8px; margin-top: 18px; }
        .auth__app { display: inline-flex; align-items: center; gap: 7px; padding: 6px 12px; border-radius: 999px; font-size: 12px; font-weight: 500; background: rgba(255,255,255,.08); border: 1px solid rgba(255,255,255,.16); color: #fff; white-space: nowrap; }
        .auth__app i { width: 7px; height: 7px; border-radius: 50%; background: rgba(255,255,255,.4); }
        .auth__app--live i { background: #4ADE80; box-shadow: 0 0 0 3px rgba(74, 222, 128, .2); }

        /* ── Diagram ───────────────────────────────────────────────────────── */
        .auth__diagram { margin: auto; padding: 24px 0; width: 100%; max-width: 640px; height: auto; display: block; }
        .auth__diagram text { font-family: var(--font-ui); }
        .auth__diagram .flow { stroke-dasharray: 3 9; animation: auth-flow 1.6s linear infinite; }
        @keyframes auth-flow { to { stroke-dashoffset: -24; } }
        @media (prefers-reduced-motion: reduce) { .auth__diagram .flow { animation: none; } .auth__diagram .pulse { display: none; } }

        /* ── Frosted callout at the foot of the card ───────────────────────── */
        .auth__glass { display: flex; align-items: flex-end; gap: 16px; padding: 18px 20px; border-radius: 16px; background: rgba(255,255,255,.10); border: 1px solid rgba(255,255,255,.18); backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px); }
        .auth__glass p { margin: 0; flex: 1; font-size: 16px; line-height: 1.45; font-weight: 500; }

        @media (max-width: 640px) {
          .hero-only { padding: 12px; }
          .auth__card { padding: 28px 20px 20px; }
        }

          </style>
        <div class="hero-only">
  <div class="auth__card">
    <img class="auth__logo" src="img/zua-lockup-light.png" alt="Zua" />
    <div class="auth__eyebrow">Zua Super App · platform.zua.ai</div>
    <h1 class="auth__headline">Connect. Govern.<br /><em>Know more.</em></h1>
    <p class="auth__lede">One institution, one secure workspace — and every Zua intelligence product on the same governed data.</p>
    <div class="auth__chips">
      <span class="auth__app auth__app--live"><i></i>Insights</span>
      <span class="auth__app"><i></i>Monitor</span>
      <span class="auth__app"><i></i>Predict</span>
    </div>
    <svg class="auth__diagram" id="authDiagram" viewBox="0 0 680 330" role="img" aria-label="Institution data sources flow into the Zua Super App, which feeds Zua Insights, Monitor and Predict"></svg>
    <div class="auth__glass">
      <p>Ready to turn your institution's data into decisions you can trust?</p>
    </div>
  </div>
</div>`

      default:
        return html`
          <div class="image-section default-left-panel">
            <div class="default-content">
              <h2 class="default-title">
                ${this.getDetailsTitle() || "Welcome"}
              </h2>
              <p class="default-subtitle">
                ${this.getDetailsSubtitle() ||
                "Complete your information to proceed"}
              </p>
            </div>
          </div>
        `;
    }
  }

  private getDetailsTitle(): string {
    try {
      if (typeof this.details === "string") {
        const details = JSON.parse(this.details);
        return details.title || "";
      } else if (this.details && typeof this.details === "object") {
        return this.details.title || "";
      }
      return "";
    } catch (e) {
      return "";
    }
  }

  private getDetailsSubtitle(): string {
    try {
      if (typeof this.details === "string") {
        const details = JSON.parse(this.details);
        return details.subtitle || "";
      } else if (this.details && typeof this.details === "object") {
        return this.details.subtitle || "";
      }
      return "";
    } catch (e) {
      return "";
    }
  }

  renderStepper() {
    if (this.sections && this.sections.length > 0) {
      const stepCount = this.sections.length;
      const steps = Array.from({ length: stepCount });

      const hideOnMobile = this.isMobileView && this.pos === 0;
      const stepperClass = hideOnMobile
        ? "stepper-hidden-mobile"
        : "stepper-visible";

      return html`
        <div class="stepper-container ${stepperClass}">
          <custom-stepper
            .steps="${steps}"
            .activeStep="${this.pos}"
            .currentStepLabel="${this.getStepLabel(this.pos)}"
            .feeds="${this.sections}"
            @step-click="${this._onStepClick}"
          ></custom-stepper>
        </div>
      `;
    }

    return html``;
  }

  getStepLabel(index: number) {
    try {
      if (typeof this.details === "string") {
        const details = JSON.parse(this.details);
        if (details.stepLabels && details.stepLabels[index]) {
          return details.stepLabels[index];
        }
      } else if (this.details && typeof this.details === "object") {
        if (this.details.stepLabels && this.details.stepLabels[index]) {
          return this.details.stepLabels[index];
        }
      }
    } catch (e) {
      // Fall through
    }
    return `Step ${index + 1}`;
  }

  private isNenaCallGateway(): boolean {
    const gatewayName = this.getGatewayName();
    return gatewayName === "nenacall";
  }

  render() {
    const cardStyle = this.paymentsPage ? "shadow-none" : "";
    const headerStyle = this.headerBgColor
      ? `background-color: ${this.headerBgColor}`
      : "";

    const mobileHeaderClass = this.isMobileView ? "mobile-fixed-header" : "";
    const isNenaCall = this.isNenaCallGateway();
    const gatewayName = this.getGatewayName();
    console.log("af ",this.af)
    
    return html`
      <div class="flex w-full h-full">
        ${this.renderImageSection()}

        <div class="content-section no-horizontal-scroll">
          <div class="card form-x-card ${cardStyle}">
            ${this.checkLoading()
              ? html`
                  <div class="overlay">
                    <div class="text-center">
                      <div
                        class="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"
                      ></div>
                      <p class="text-gray-600">Loading...</p>
                    </div>
                  </div>
                `
              : ""}

            ${this.checkLoading()
              ? html`
                  <div class="pro-container">
                    <div class="w-full bg-gray-200 rounded-full h-2">
                      <div
                        class="bg-blue-600 h-2 rounded-full animate-pulse"
                      ></div>
                    </div>
                  </div>
                `
              : ""}

            <div class="card-content ${this.checkForDialog()}">
              <div class="card-content-scrollable scrollbar-custom">
                <div class="form-scroll-container scrollbar-custom">
                  

                  ${this.isMobileView && !isNenaCall && this.logo
                    ? html`
                        <img
                          src=${`media/${this.logo}`}
                          alt="Logo"
                          class="mobile-logo"
                        />
                      `
                    : ""}

                  <div class="form-container">
                    <div class="form-content">
                      <header
                        class="card-header ${mobileHeaderClass}"
                        style="${headerStyle}"
                      >
                        <div class="header-content">
                         
                        ${gatewayName == "nenacall" ? html`
                          <div class="mb-2">
                    <img src=${`media/${this.logo}`} alt="Nenacall Logo" class="h-10 md:h-12 w-auto object-contain">
                </div>` :html``}

                          <!-- Always render stepper when there are sections -->
                          ${this.renderStepper()}
                          <p class="header-title">
                            ${this.af.title || this.feed.title}
                          </p>

                        ${gatewayName == "nikobizznet" ? html`  <p>${this.getDetailsSubtitle()}</p>` : html ``}
                        </div>
                      </header>

                      <slot name="body"></slot>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  setCardContentHeight() {
    let section = document.querySelector("section-page");

    if (this.maxHeight || this.height) {
      if (
        section != null &&
        section.id == "dialog" &&
        window.TEMPLATE == "service"
      ) {
        const cardContent = this.shadowRoot?.querySelector(
          ".card-content-scrollable"
        ) as HTMLElement;
        if (cardContent) {
          if (this.height) cardContent.style.height = this.height;
          if (this.maxHeight) cardContent.style.maxHeight = this.maxHeight;
        }
      }
    }
  }

  _notifyPosChange(newPos: number) {
    this.dispatchEvent(
      new CustomEvent("pos-change", {
        bubbles: true,
        composed: true,
        detail: { pos: newPos },
      })
    );
  }

_goToStep(index: number) {
  if (index < 0 || index >= this.sections.length) return;
  
  // Check if we're going backwards
  if (index < this.pos) {
    // Dispatch event that will trigger FormRender to clear future steps
    this.dispatchEvent(new CustomEvent('step-navigate-back', {
      bubbles: true,
      composed: true,
      detail: { newPos: index }
    }));
  }
  
  this.pos = index;
  this._notifyPosChange(this.pos);
}

  checkForDialog() {
    return this.isSectionPage ? "dialog-content" : "";
  }

  checkLoading() {
    return this.loading === "true";
  }
}